import React from "react";

import { Typography } from "@mui/material";
import type { AICardConfig, CardConfig } from "store/types";

interface Props {
  config: AICardConfig;
  onUpdateConfig: (c: CardConfig) => void;
}

export const AISettings: React.FC<Props> = () => {
  return (
    <Typography sx={{ fontSize: 12, color: "#6B7280", lineHeight: "18px" }}>
      Type your question directly on the card and press the send button to ask the AI.
    </Typography>
  );
};
